<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in comList" :label="item.title" :name="item.name" lazy
        :key="item.name">
      </el-tab-pane>
      <InterForm @querySubmit="queryHandler" @overEmit="getDataSource" prentType="small" :tableType="tableType"
        :forwarder="forwarder" :forwarderCompany="forwarderCompany" ref="InterForm" :selectedRows="selectedRows" :clearSelect="clearAndReset" :isBatchSearch="isBatchSearch" :logList="logList"/>
      <InterList :tableType="tableType" @refeash="refeash" :dataSource="dataSource" :clean='clean'
        @pageChange="pageChangeCall" @selectChange="selectChangeCall" prentType="small" ref="interlist"
        :forwarder="forwarder" :total="query.total"></InterList>
    </el-tabs>
    <ErrorModal ref="errorModalRef"/>
  </div>
</template>

<script>
import InterForm from './components/InterForm'
import InterList from "./components/InterList";
import { getInvoicePage, getInvoiceForwarder, getForwarderCompany, invoiceExport, d2cHasMadePage } from "@/apis/outStock";
import ErrorModal from './components/ErrorModal.vue';
export default {
  title: '小包发货',
  name: "smallBagShip",
  components: {
    InterForm,
    InterList,
    ErrorModal
  },
  data() {
    return {
      activeName: 'ToBeProduced',
      forwarder:[],
      forwarderCompany: [],
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      paramsCache: {},
      clean: false,
      selectedRows: [],
      dataSource: [],
      tableType: 'ToBeProduced',
      // 是否批量搜索物流单号
      isBatchSearch: false,
      logList: []
    }
  },
  created() {
  },
  computed: {
    comList: function () {
      return [{ name: 'ToBeProduced', title: '发票待制作' }, { name: 'AlreadyProduced', title: '发票已制作' }, { name: 'neverProduced', title: '无需制作发票' }]
    }
  },
  methods: {
    handleClick(e) {
      this.tableType = e.name
      this.$refs.InterForm.restSubmit()
    },
    queryHandler: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
      };
      this.query.current = 1
      this.getDataSource()
      this.clearSelect()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    selectChangeCall: function (rows) {
      this.selectedRows = rows;
    },
    refeash() {
      this.getDataSource()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    getDataSource: function () {
      const invoiceStatus = ['ToBeProduced', 'AlreadyProduced', 'neverProduced'].indexOf(this.tableType)
      // 获取列表数据
      this.selectedRows = [];
      const params = {
        ...this.query,
        pageNum: this.query.current,
        invoiceStatus,
        /** 大件普通 */
        deliveryType: 2
      };
      this.paramsCache = params
      this.clean = true;
      if(this.tableType == 'AlreadyProduced') {
        delete params.skuQuantityExceeds
        delete params.mergeFlag
      }
      const api = this.tableType == 'AlreadyProduced' ? d2cHasMadePage : getInvoicePage
      if(params.logisticsCodeList && params.logisticsCodeList.length > 0) {
        this.isBatchSearch = true
      } else {
        this.isBatchSearch = false
      }
      api(params)
        .then((res) => {
          if(res.code === 26020044) {
            this.$refs.errorModalRef.open(res.msg.split(','))
          }
          const { records=[], total=0} =  res?.data || {}
          // const {
          //   data: { deliveryReviewPage: { total = 0, records = [] } },
          // } = res;
          this.dataSource = records
          this.query.total = total
          this.logList = this.isBatchSearch ? params.logisticsCodeList : []
          // console.log(9996669, res)
        })
        .finally((_) => {
          this.clean = false;
        });
    getInvoiceForwarder({
      invoiceStatus: this.tableType == 'ToBeProduced'?0:1,
        deliveryType:2
      }).then(res=>{
        if(res.code == 0){
          this.forwarder = res.data
          if(res.data.length == 0){
            this.$message.warning('货代渠道请求失败')
          }
        }
      }),
      getForwarderCompany({
        invoiceStatus: this.tableType == 'ToBeProduced'?0:1,
          deliveryType:2
      }).then(res => {
          this.forwarderCompany = res.data
          if(res.data.length == 0){
            this.$message.warning('货代公司请求失败')
          }
      })
    },
    toInvoiceExport(){
      console.log('toInvoiceExport')
      let params
      if(this.selectedRows.length){
        params = {
          logisticsCodeList: this.selectedRows.map(v => {
            return v.logisticsCode
          })
        }
      }else{
        params = this.paramsCache
      }
      invoiceExport(params).then(res => {
        console.log(res)
        if(res.code == 0){
          this.$message.success('导出成功，请前往报表-数据导出中下载表格')
        }
      })
    },
    // 清除选中
    clearSelect(){
      try{
        this.$refs.interlist.$refs.wmsTable.selectedRowsCache = []
        this.$refs.interlist.$refs.wmsTable.selectedRowKeysCache = []
        this.$refs.interlist.$refs.wmsTable.selectedRows = []
        this.$refs.interlist.$refs.wmsTable.selectedRowKeys = []
      } catch {}
    },
    clearAndReset(){
      this.clearSelect()
      this.$refs.InterForm.restSubmit()
    }
  },
  mounted(){
    this.clearSelect()
  }
}
</script>